<template>
  <div>
    <CitySelectBottomSheet
      :name="citiesBottomSheetFrom"
      :title="$t('main.cities.departure')"
      :search-placeholder="$t('main.cities.departurePlaceholder')"
      :fetch-cities="fetchCities"
      :min-query-length="0"
      :popular-routes="searchCities.lib.getDeparturePopularRoutes()"
      is-children-hidden
      search-history-prefix="free-avia"
      should-show-history
      @onCitySelect="handleLocationSelect($event, 'dep')"
    >
      <template #subDirectionIcon>
        <img src="@/assets/images/plane.svg" alt="" width="24" height="24" />
      </template>
    </CitySelectBottomSheet>
    <CitySelectBottomSheet
      :name="citiesBottomSheetTo"
      :title="$t('main.cities.arrival')"
      :search-placeholder="$t('main.cities.arrivalPlaceholder')"
      :fetch-cities="fetchCities"
      :min-query-length="0"
      :popular-routes="searchCities.lib.getArrivalPopularRoutes()"
      is-children-hidden
      search-history-prefix="free-avia"
      should-show-history
      @onCitySelect="handleLocationSelect($event, 'arr')"
    >
      <template #subDirectionIcon>
        <img src="@/assets/images/plane.svg" alt="" width="24" height="24" />
      </template>
    </CitySelectBottomSheet>
  </div>
</template>

<script setup lang="ts">
  import { CitySelectBottomSheet } from 'freedom-shared';
  import { searchCities, controllerModel } from 'shared';
  import type { MappedLocation } from 'shared';

  import { fetchCities } from '@/shared/api';

  const props = defineProps<{
    citiesBottomSheetTo: string;
    citiesBottomSheetFrom: string;
    source: string;
  }>();

  const emit = defineEmits<{
    onDepSelect: [city: MappedLocation];
    onArrSelect: [city: MappedLocation];
  }>();

  const bottomSheet = controllerModel.useBottomSheet();

  const handleLocationSelect = (location: MappedLocation, type: string) => {
    if (type === 'arr') {
      emit('onArrSelect', location);
      bottomSheet.hide(props.citiesBottomSheetTo);
    } else {
      emit('onDepSelect', location);
      bottomSheet.hide(props.citiesBottomSheetFrom);
    }
  };
</script>
